/* eslint-disable import/no-extraneous-dependencies */
import { createApp } from 'vue';
import router from './router';
import '@/assets/main.scss';
import '@/assets/style.css';
import { VueMasonryPlugin } from 'vue-masonry/src/masonry.plugin';
import { createHead } from '@unhead/vue/client';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import store from './store';
import VueInputMask from './helpers/vue-inputmask';
import SvgIcon from './components/SvgIcon.vue';
import '@baza/assets/landing-theme.css';
import { emitter } from '@baza/helpers/eventBus';
import { createPinia } from 'pinia';

const head = createHead();

const app = createApp(App);

app.config.globalProperties.emitter = emitter;

app.use(router)
    .use(createPinia())
    .use(store)
    .use(VueInputMask)
    .use(head)
    .use(VueCookies, { expires: '7d' })
    .use(VueMasonryPlugin)
    .component('svg-icon', SvgIcon);
app.mount('#app');

export default app;
